module.exports = __webpack_public_path__ + "static/media/implantes-mobile.06f3e25f.png";